/**
 * Vue 3 全局过滤器插件
 * 替代 Vue 2 的 Vue.filter
 */
import * as formats from '@/compositions/filters/format'
import * as dictionaries from '@/compositions/filters/dictionary'

export default {
  install(app) {
    // 将所有格式化函数挂载到全局属性 $filters 上
    const filters = {
      ...formats,
      ...dictionaries
    }

    // 方式1: 挂载到 globalProperties,可在模板中通过 $filters 访问
    app.config.globalProperties.$filters = filters

    // 方式2: 也可以单独挂载每个函数(可选)
    // Object.keys(filters).forEach(key => {
    //   app.config.globalProperties[`$${key}`] = filters[key]
    // })
  }
}
